import { CSSProperties } from "react";

export const XCubeSvg = ({
  width,
  color,
  style,
}: {
  width: number;
  color: string;
  style?: CSSProperties;
}) => {
  return (
    <svg width={width} height={width} viewBox="0 0 14 15" style={style}>
      <g filter="url(#filter0_d_219_429)">
        <path d="M13 10.5L7 13.5V6L13 3.5V10.5Z" fill="#989898" />
        <path d="M1 10.5L7 13.5V6L1 3.5V10.5Z" fill="#ADADAD" />
        <path d="M7 6L1 3.5L7 1L13 3.5L7 6Z" fill="#CCCCCC" />
        <path
          d="M13 3.5L7 1L1 3.5V10.5L7 13.5L13 10.5V3.5Z"
          fill={color}
          fillOpacity="0.68"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_219_429"
          x="0"
          y="0"
          width="14"
          height="14.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.79 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_429"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_429"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
